/**
 * Main.js
 *
 * @since 1.0.0
 */

import Raven from 'raven-js'
import ObserveFontFace from './modules/ObserveFontFace'
import LazyLoadBackground from './modules/LazyLoadBackground'
import Slider from './modules/Slider'
import AnimatePerspective from './modules/AnimatePerspective'
import FadeGallery from './modules/FadeGallery'
import FAQ from './modules/FAQ'
import Maps from './modules/Maps'
import PageHeader from './modules/PageHeader'
import ScrollDown from './modules/ScrollDown'
import Youtube from './modules/Youtube'
import Vimeo from './modules/Vimeo'
import StickyNotice from './modules/StickyNotice'
;(function IIFE() {
  if (process.env.NODE_ENV === 'production') {
    Raven.config('https://8c1b9a2bae3f4282948d693bb38f8ecf@sentry.io/162902').install()
  }
  ObserveFontFace()
  LazyLoadBackground()
  Slider()
  AnimatePerspective()
  FadeGallery()
  FAQ()
  Maps()
  PageHeader()
  ScrollDown()
  Youtube()
  Vimeo()
  StickyNotice()
})()



// WEBPACK FOOTER //
// ./src/js/main.js